<template>
  <div class="goodsType-page">
    <el-tabs v-model="goodsTypeTab" @tab-click="goodsTypeTabHandleClick">
      <el-tab-pane label="当期网络零售额" name="currentSales">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="currentSalesForm" label-width="92px">
            <el-form-item label="时间：">
              <el-col :span="3" style="width: 125px">
                <span :class="wholeTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                      @click="twelveMonth('whole')">近13个月</span>
                <span :class="wholeTime=='2'?'cursor-pointer text-1E88E5':' cursor-pointer'" @click="wholeTime == '2'">月度</span>
              </el-col>
              <!--              <span class="margin-r-10 cursor-pointer">季度</span>-->
              <el-col :span="4">
                <el-date-picker v-model="currentSalesForm.startTime" type="month" placeholder="选择日期" class="width-z100"
                                size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
              <el-col class="text-center" :span="1">-</el-col>
              <el-col :span="4">
                <el-date-picker v-model="currentSalesForm.endTime" placeholder="选择日期" type="month" class="width-z100"
                                size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
            </el-form-item>
<!--            <el-form-item class="text-right">-->
<!--              <el-button type="primary" v-on:click="getWholeList">确定</el-button>-->
<!--              &lt;!&ndash;              <el-button>取消</el-button>&ndash;&gt;-->
<!--            </el-form-item>-->
          </el-form>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">
          <chart ref="chart1" :options="currentSalesOptions" autoresize class="width-z100 margin-t-30"></chart>
          <el-table :data="currentSalesTable" stripe height="340" class="float-left border-DEDEDE margin-t-30 margin-b-20">
            <el-table-column prop="times" label="时间" align="center"></el-table-column>
            <el-table-column prop="s_absoulte_value" label="实物网络零售额（万元）" align="center"></el-table-column>
            <el-table-column prop="f_absoulte_value" label="非实物网络零售额（万元）"  width="158"align="center"></el-table-column>
            <el-table-column prop="s_absoulte_value_yoy" label="实物同比（%）" width="158" align="center"></el-table-column>
            <el-table-column prop="f_absoulte_value_yoy" label="非实物同比（%）" align="center"></el-table-column>
            <el-table-column prop="s_absoulte_value_pro" label="实物占比（%）" width="158" align="center"></el-table-column>
            <el-table-column prop="f_absoulte_value_pro" label="非实物占比（%）" align="center"></el-table-column>
          </el-table>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="累计网络零售额" name="cumulativeSales">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="currentSalesForm" label-width="92px">
            <el-form-item label="时间：">
              <el-col :span="3" style="width: 125px">
                <span :class="wholeTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                      @click="twelveMonth()">近13个月</span>
                <span :class="wholeTime=='2'?'cursor-pointer text-1E88E5':' cursor-pointer'">月度</span>
              </el-col>
              <!--              <span class="margin-r-10 cursor-pointer">季度</span>-->
              <el-col :span="4">
                <el-date-picker v-model="currentSalesForm.startTime" type="month" placeholder="选择日期" class="width-z100"
                                size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
              <el-col class="text-center" :span="1">-</el-col>
              <el-col :span="4">
                <el-date-picker v-model="currentSalesForm.endTime" placeholder="选择日期" type="month"
                                @change="getWholeList(wholeTime = 2)"
                                class="width-z100" size="small" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
            </el-form-item>
<!--            <el-form-item class="text-right">-->
<!--              <el-button type="primary" v-on:click="getWholeList">确定</el-button>-->
<!--              &lt;!&ndash;              <el-button>取消</el-button>&ndash;&gt;-->
<!--            </el-form-item>-->
          </el-form>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">
          <chart ref="chart1" :options="currentSalesOptions" autoresize class="width-z100 margin-t-30"></chart>
          <el-table :data="currentSalesTable" stripe height="340" class="float-left border-DEDEDE margin-t-30 margin-b-20">
            <el-table-column prop="times" label="时间" align="center"></el-table-column>
            <el-table-column prop="s_absoulte_value" label="实物网络零售额（万元）" align="center"></el-table-column>
            <el-table-column prop="f_absoulte_value" label="非实物网络零售额（万元）" align="center"></el-table-column>
            <el-table-column prop="s_absoulte_value_yoy" label="实物同比（%）" width="158" align="center"></el-table-column>
            <el-table-column prop="f_absoulte_value_yoy" label="非实物同比（%）" align="center"></el-table-column>
            <el-table-column prop="s_absoulte_value_pro" label="实物占比（%）" width="158" align="center"></el-table-column>
            <el-table-column prop="f_absoulte_value_pro" label="非实物占比（%）" align="center"></el-table-column>
          </el-table>
        </el-card>
      </el-tab-pane>
    </el-tabs>
    <p class="margin-l-30 margin-r-20 font-14 text-8A8A8A">
      注：<br/>
      1.根据国家统计局定义，商品和服务包括实物商品和非实物商品（如虚拟商品、服务类商品）；<br/>
      2.按照国家统计局《批发和零售业统计报表制度》及商务部《网络零售监测指标规范：商品及服务分类及代码》，将实物商品划分为粮油和食品类、饮料类、烟酒类、服装和鞋帽及针纺织品类、 化妆品类、金银珠宝类、日用品类、体育和娱乐用品类、书报杂志类、电子出版物及音像制品类、家用电器及音像器材类、中西药品类、文化办公用品类、家具类、通讯器材类、建筑及装潢材料 类、汽车类、五金和电料类、煤炭及制品类、木材及制品类、石油及制品类、化工材料及制品类、金属材料类、机电产品及设备类、种子饲料类、棉麻类、其他类，共27个大类；
      <br/>3、服务类商品划分为餐饮服务、住宿服务、旅游服务、通信服务、教育服务、文化和体育及娱乐服务、居民生活服务、交通仓储邮政服务、非金融机构支付服务、咨询服务、广告会展服务、其他 服务，共12个大类。虚拟商品包括充值缴费、IP卡/网络电话/手机号码、电子消费卡券、游戏/点卡/账号/道具/代练、其他虚拟商品。
    </p>
  </div>
</template>

<script>
  export default {
    name: 'localArea',
    data () {
      return {
        goodsTypeTab: 'currentSales',
        chooseType: '当期网络零售额',//当前选择查询条件
        currentSalesOptions: {}, //当期网络零售额图表
        currentSalesTable: [],//当期网络零售额表格
        currentSalesForm: {startTime: '', endTime: ''},//当期网络零售额筛选条件
        wholeTime: '1',
        cumulativeSalesOptions: {},//累计网络零售额图表
        currentRetailOptions: {},//当期网络零售量图表
        cumulativeRetailOptions: {},//累计网络零售量图表
        peopleEngagedNumOptions: {},//从业人数图表
        ExpressDeliveryVolumeOptions: {},//快递量图表

        productTime: '1',
        productForm: {way: '1', endTime: ''}, //商品大类筛选条件
        transactionTime: '1',
        transactionTitle: '',
        transactionForm: {way: '1', resource: '1', startTime: '', endTime: '', platform: '全部'},//交易平台筛选条件
        regionDis: true,
        //表格数据

        productTwoTable: [],
        pickerOptions: {
          disabledDate: (time) => {
            // console.log(time.getMonth());
            let nowDate = new Date()
            let day = nowDate.getDate()
            nowDate.setDate(1);
            if (day > 14) {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-1);
              }
            } else {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(10);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else if(nowDate.getMonth()==1){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-2);
              }
            }
            if(time.getFullYear()<2020){
              nowDate.setFullYear(time.getFullYear()-1)
              // console.dir(nowDate)
            }return time > nowDate
          }
        },
      }
    },
    mounted () {

    },
    created () {
      this.$emit('public_header', true)
      this.twelveMonth()
      // this.oneMonth()
    },
    methods: {

      goodsTypeTabHandleClick (tab, event) {
        if (tab.name == 'cumulativeSales') {
          this.chooseType = '累计网络零售额'
          this.getWholeList()
        }
        if (tab.name == 'currentSales') {
          this.chooseType = '当期网络零售额'
          this.getWholeList()
        }

      },
      //商品类型列表
      getWholeList () {
        this.$http.get(this.header + '/qyjc/goodsType', {
          params: {
            index_type: this.chooseType,
            sMonth: this.currentSalesForm.startTime,
            eMonth: this.currentSalesForm.endTime
          }
        }).then(res => {
          if (res.data.code == 0) {
            let wholeList = {xTime: [], yMaterialMoney: [],yOnlineMoney:[],materialYoy:[],onlineYoy:[]}
            res.data.list.forEach((y, index) => {
              wholeList.xTime.push(y.times)
              let ymaterial = {
                value: y.s_absoulte_value_pro,
                unit: '%'
              }
              let yonline = {
                value: y.f_absoulte_value_pro,
                unit: '%'
              }
              let ymaterialYoy = {
                value: y.s_absoulte_value_yoy,
                unit: '%'
              }
              let yonlineYoy = {
                value: y.f_absoulte_value_yoy,
                unit: '%'
              }
              wholeList.yMaterialMoney.push(ymaterial)
              wholeList.yOnlineMoney.push(yonline)
              wholeList.materialYoy.push(ymaterialYoy)
              wholeList.onlineYoy.push(yonlineYoy)
            })
            this.currentSalesTable = res.data.list.reverse()
            //当期网络零售额图表
            this.currentSalesOptions = {
              title: {//图表标题
                text: '各商品类型' + this.chooseType + '变化趋势',
                left: 'left',
                textStyle: {
                  color: '#313131',
                  fontSize: 18,
                  fontWeight: 300
                },
              },
              toolbox: { //图表工具箱
                feature: {
                  magicType: {show: false, type: ['line', 'bar']},
                  restore: {show: false},
                  saveAsImage: {show: true}
                }
              },
              tooltip: { // 鼠标悬浮
                backgroundColor: 'rgba(50,50,50,0.7)',
                trigger: 'axis',
                axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                  type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                },
              },
              legend: {//图表说明  horizontal竖着显示vertical横显示
                orient: 'horizontal',
                y: 'bottom',
                // x: 'left',
                textStyle: {
                  color: '#666',
                  fontSize: 14
                },
                data: ['实物占比', '非实物占比','实物同比','非实物同比']
              },
              xAxis: {
                type: 'category',
                data: wholeList.xTime,

                axisLine: {
                  lineStyle: {
                    color: '#666'
                  }
                }
              },
              yAxis: [
                {
                  type: 'value',
                  name: '%',
                  min: 0,
                  max: 100,
                  axisLine: {
                    lineStyle: {
                      color: '#666'
                    }
                  },
                },{
                  type: 'value',
                  name: '%',
                  // axisLabel: {
                  //   formatter: '{value} %'
                  // },
                  splitLine:{//去除网格线
                    show:false
                  },
                  axisLine: {
                    lineStyle: {
                      color: '#666'
                    }
                  },
                }],
              series: [{
                name: '实物占比',
                type: 'bar',
                stack: '总量',
                barCategoryGap: '60%',
                itemStyle: {
                  normal: {
                    color: '#7888ed'
                  }
                },
                data:wholeList.yMaterialMoney,
                smooth: true
              }, {
                name: '非实物占比',
                type: 'bar',
                stack: '总量',
                itemStyle: {
                  normal: {
                    color: '#66c6db'
                  }
                },
                data: wholeList.yOnlineMoney
              }, {
                name: '实物同比',
                type: 'line',
                yAxisIndex: 1,
                itemStyle: {
                  normal: {
                    color: '#649CEE'
                  }
                },
                data: wholeList.materialYoy
              }, {
                name: '非实物同比',
                type: 'line',
                yAxisIndex: 1,
                itemStyle: {
                  normal: {
                    color: '#EB7D6F'
                  }
                },
                data: wholeList.onlineYoy
              }]
            }
          } else {
            this.$alert(res.data.msg)
          }

        })
      },
      //选择近13个月
      twelveMonth (val) {
        let dataArr = []
        let data = new Date()
        let day = data.getDate()
        data.setMonth(data.getMonth() + 1, 1)//获取到当前月份,设置月份
        for (var i = 0; i < 15; i++) {
          data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
          var m = data.getMonth() + 1
          m = m < 10 ? '0' + m : m
          dataArr.push(data.getFullYear() + '-' + (m))
        }
        this.wholeTime = '1'
        if (day > 14) {
          this.currentSalesForm.startTime = dataArr[13]
          this.currentSalesForm.endTime = dataArr[1]
        } else {
          this.currentSalesForm.startTime = dataArr[14]
          this.currentSalesForm.endTime = dataArr[2]
        }
        this.getWholeList()

      },
      //计算最大值
      calMax (arr) {
        let max = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (max < el1.value) {
              max = el1.value
            }
          }
          // })
        })
        let maxInt = Math.ceil(max / 9.5)//不让最高的值超过最上面的刻度
        let maxVal = maxInt * 10//让显示的刻度是整数
        return maxVal
      },

      //计算最小值
      calMin (arr) {
        let min = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (min > el1.value) {
              min = el1.value
            }
          }
        })
        // })
        let minInt = Math.floor(min / 10)
        let minVal = minInt * 10//让显示的刻度是整数
        return minVal
      },

      //选择近1个月
      // oneMonth (val) {
      //   var dataArr = []
      //   var data = new Date()
      //   var year = data.getFullYear()
      //   data.setMonth(data.getMonth() + 1, 1)//获取到当前月份,设置月份
      //   for (var i = 0; i < 3; i++) {
      //     data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
      //     var m = data.getMonth() + 1
      //     m = m < 10 ? '0' + m : m
      //     dataArr.push(data.getFullYear() + '-' + (m))
      //   }
      //   if (val == 'city') {
      //     this.wholeTime = '1'
      //     // this.cityForm.startTime = dataArr[1]
      //     this.cityForm.endTime = dataArr[2]
      //     this.getCityList()
      //   } else if (val == 'product') {
      //     this.productTime = '1'
      //     // this.productForm.startTime = dataArr[1]
      //     this.productForm.endTime = dataArr[2]
      //     this.getProductList()
      //   } else if (val == 'transaction') {
      //     this.transactionTime = '1'
      //     // this.transactionForm.startTime = dataArr[1]
      //     this.transactionForm.endTime = dataArr[2]
      //     this.getTransactionList()
      //   } else {
      //     this.wholeTime = '1'
      //     this.cityForm.endTime = dataArr[2]
      //     this.productTime = '1'
      //     // this.productForm.startTime = dataArr[1]
      //     this.productForm.endTime = dataArr[2]
      //     this.transactionTime = '1'
      //     // this.transactionForm.startTime = dataArr[1]
      //     this.transactionForm.endTime = dataArr[2]
      //     this.getCityList()
      //     this.getTransactionList()
      //     this.getProductList()
      //   }
      //   console.dir(this.cityForm)
      // },
    }
  }
</script>

<style>
  .goodsType-page .el-tabs__item {
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    width: 180px;
    height: 45px;
    padding: 0px;
    /*color: #CED4DF;*/
  }

  .goodsType-page .el-tabs__active-bar {
    background-color: transparent;
  }

  .goodsType-page .el-tabs__header {
    margin-left: 30px;
    margin-right: 30px;
    margin-bottom: 0px;
  }

  .goodsType-page .el-tabs__item.is-active {
    background-color: #3865A5;
    color: white;
  }

  .goodsType-page .el-form-item {
    margin-bottom: 0;
  }

  .goodsType-page .el-radio, .goodsType-page .el-form-item__label {
    color: #666;
  }

</style>



// WEBPACK FOOTER //
// src/components/area/goodsType.vue